import styled from '@emotion/styled';
import MuiAccessTime from '@mui/icons-material/AccessTime';
import MuiSignalCellularAlt from '@mui/icons-material/SignalCellularAlt';
import MuiAvatar from '@mui/material/Avatar';
import MuiIconButton from '@mui/material/IconButton';

import { greyish, turquoise } from '~/styles';

// tslint:disable-next-line: export-name
export const DurationIconButton = styled(MuiIconButton)`
  display: flex;
  border-radius: unset;
  align-items: center;
  margin-top: 0;
  padding: 0;
  cursor: auto;
  &:hover {
    background: none;
  }
  margin: auto;
  margin-right: initial;
`;

export const AccessTime = styled(MuiAccessTime)`
  color: ${turquoise};
`;

export const DurationDark = styled.span`
  color: ${greyish};
  font-size: 12px;
  line-height: 16px;
  font-weight: 200;
  padding-left: 4px;
`;

export const DurationLight = styled(DurationDark)`
  color: #fff;
`;

export const Avatar = styled(MuiAvatar)`
  margin-right: 8px;
  font-size: 16px;
  line-height: 24px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const AuthorNameLight = styled.span`
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  font-weight: 200;
`;

export const SignalCellularAlt = styled(MuiSignalCellularAlt)`
  color: ${turquoise};
  font-size: 22px;
  margin-left: auto;
`;
